import APIService from "./APIService";

/**
 * Service for handling Account-related API operations
 */
class AccountAPI {
  /**
   * Get account information by user UUID
   *
   * @param {string} uuid - User UUID
   * @returns {Promise} Promise that resolves with account data
   */
  static async getAccountByUserUuid() {
    try {
      return await APIService.get(`/api/v1/base/accounts/user`);
    } catch (error) {
      console.error("[AccountAPI] Error getting account by user UUID:", error);
      throw error;
    }
  }

  /**
   * Get user count for an account
   *
   * @param {number} accountId - Account ID
   * @returns {Promise} Promise that resolves with user count data
   */
  static async getUserCountByAccountId(accountId) {
    try {
      return await APIService.get(
        `/api/v1/base/accounts/${accountId}/user-count`,
      );
    } catch (error) {
      console.error(
        "[AccountAPI] Error getting user count for account:",
        error,
      );
      throw error;
    }
  }

  /**
   * Update the company profile for the authenticated account owner's account.
   * Restricted server-side to the account owner (account_admin).
   *
   * @param {Object} payload - { name, description, industry, employeeCount }
   * @returns {Promise} Promise that resolves with the updated account data
   */
  static async updateCompanyProfile(payload) {
    try {
      return await APIService.put(
        `/api/v1/base/accounts/company-profile`,
        payload,
      );
    } catch (error) {
      console.error("[AccountAPI] Error updating company profile:", error);
      throw error;
    }
  }
}

export default AccountAPI;
